<template>
    <div class="app-container">
      <ViewForm v-if="!$store.getters.cusId" />
      <ViewFormUser v-else />
    </div>
  </template>
  <script>
  import ViewForm from '@/views/center-business/purchase/order/csg-admin/detail';
  import ViewFormUser from '@/views/center-business/purchase/order/csg/detail';
  export default {
    name: 'BusinessPurchaseOrderCsgAdminDetail',
    components: {
      ViewForm,
      ViewFormUser
    },
  };
  </script>
